import React, { useEffect, useState, useRef } from 'react';
import { motion, useMotionValue, useTransform } from 'framer-motion';
export const GradientEffect = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [{
    width,
    height,
    top,
    left
  }, measure] = useElementDimensions(ref);
  const gradientX = useMotionValue(0.5);
  const gradientY = useMotionValue(0.5);
  const background = useTransform(() => `conic-gradient(from 0deg at calc(${gradientX.get() * 100}% - ${left}px) calc(${gradientY.get() * 100}% - ${top}px), #0cdcf7, #2E6BFF, #ff0088, #0cdcf7)`);
  return;
};
/**
 * Custom hook to measure element dimensions
 */
function useElementDimensions(ref: React.RefObject<HTMLDivElement | null>): [{
  width: number;
  height: number;
  top: number;
  left: number;
}, VoidFunction] {
  const [size, setSize] = useState({
    width: 0,
    height: 0,
    top: 0,
    left: 0
  });
  function measure() {
    if (!ref.current) return;
    setSize(ref.current.getBoundingClientRect());
  }
  // Initialize measurements
  useEffect(() => {
    measure();
    // Add window resize handler
    const handleResize = () => measure();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return [size, measure];
}